<template>
    <div class='videoViewSetting'>
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bannerConfig.header}}</span>
                <uploadImage :imageUrl="setTingObj.bannerConfig.url" @deleteUrl="deleteBannerUrl" @updateUrl="updateBannerUrl"/>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.videoConfig.header}}</span>
                <uploadVideo :imageUrl="setTingObj.videoConfig.url" @deleteUrl="deleteVideoUrl" @updateUrl="updateVideoUrl"/>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.scaleStyle.title}} ({{setTingObj.scaleStyle.list[setTingObj.scaleStyle.type].val}})</span>
                <radio :list="setTingObj.scaleStyle.list" :type="setTingObj.scaleStyle.type" @change="updateScaleStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.prConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.prConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue';
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import color from '@/components/decoration/common/color.vue';
import radio from '@/components/decoration/common/radio.vue';
import uploadImage from '@/components/decoration/common/uploadImage.vue'
import uploadVideo from '@/components/decoration/common/uploadVideo.vue'
export default {
    components: {
        tab,
        sliderAndInput,
        radio,
        color,
        uploadImage,
        uploadVideo
    },
    data(){
        return {
            status: 'content'
        }
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    methods: {
        getTab(e){
            this.status = e
        },
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
        updateScaleStyle(type){
            this.setTingObj.scaleStyle.type = type
        },
        deleteBannerUrl(){
            this.setTingObj.bannerConfig.url = ''
        },
        updateBannerUrl(url){
            this.setTingObj.bannerConfig.url = url
        },
        deleteVideoUrl(){
            this.setTingObj.videoConfig.url = ''
        },
        updateVideoUrl(url){
            this.setTingObj.videoConfig.url = url
        }
    }
}
</script>

<style scoped lang="scss">

</style>